import React from 'react';
export const Spotlight = ({
  className = ''
}: {
  className?: string;
}) => {
  return <div className={`absolute top-0 left-0 right-0 h-[600px] pointer-events-none overflow-hidden z-0 ${className}`} data-id="element-434">
      {/* Main top spotlight */}
      <div className="absolute left-1/2 -translate-x-1/2 top-[-150px] w-[1000px] h-[600px] bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gold-300/20 via-gold-300/5 to-transparent blur-3xl rounded-full" data-id="element-435"></div>

      {/* Subtle bokeh particles */}
      <div className="absolute top-24 left-[15%] w-4 h-4 bg-gold-300/40 rounded-full blur-[2px]" data-id="element-436"></div>
      <div className="absolute top-48 right-[20%] w-6 h-6 bg-gold-400/20 rounded-full blur-md" data-id="element-437"></div>
      <div className="absolute top-64 left-[35%] w-3 h-3 bg-white/50 rounded-full blur-[1px]" data-id="element-438"></div>
      <div className="absolute top-32 right-[40%] w-8 h-8 bg-beige-200/30 rounded-full blur-lg" data-id="element-439"></div>
      <div className="absolute top-80 left-[60%] w-5 h-5 bg-gold-300/20 rounded-full blur-sm" data-id="element-440"></div>
    </div>;
};